import angular, { IPromise } from "angular";
import { Gen } from "./api";
import { createJsonParseReviver } from "./convertDateStringsToDates";

export class ApiClient extends Gen.Client {
    public static componentName = "ApiClient";
    
    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super($http, $q, baseUrl);
        this.jsonParseReviver = createJsonParseReviver();
    }
}

export class MarketClient extends Gen.MarketClient {
    public static componentName = "MarketClient";
    
    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super($http, $q, baseUrl);
        this.jsonParseReviver = createJsonParseReviver();
    }
}

export class ScoringCardsClient extends Gen.ScoringCardsClient {
    public static componentName = "ScoringCardsClient";
    
    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super($http, $q, baseUrl);
        this.jsonParseReviver = createJsonParseReviver();
    }
}

export class IMSIOClient extends Gen.IMSIOClient {
    public static componentName = "IMSIOClient";
    
    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super($http, $q, baseUrl);
        this.jsonParseReviver = createJsonParseReviver();
    }
}

angular
    .module("topline.services")
    .service(ApiClient.componentName, ["$http", "$q", ApiClient])
    .service(MarketClient.componentName, ["$http", "$q", MarketClient])
    .service(ScoringCardsClient.componentName, ["$http", "$q", ScoringCardsClient])
    .service(IMSIOClient.componentName, ["$http", "$q", IMSIOClient]);

export function wrapPromiseWithStatus<T>(promise: IPromise<T>): IPromise<{ status: number; data: T }> {
    return promise
        .then((data: T) => ({ status: 200, data }))
        .catch((error: any) => ({
            status: error.status || 500,
            data: error.data
        }));
}
